import React, {memo, useEffect, useState} from 'react';
import {View, Text} from 'react-native';

import { StyleSheet } from 'react-native';
import {colorPalette} from '../../../core/config/color.config';

import {ConsultationRequestResBody} from '../../server/types/consultation.types';

import useStores from '../../stores/useStores';

import ConsultationRequestMessage from './ConsultationRequestMessage';
import ConsultationMessageAttachment from './ConsultationMessageAttachment';
import ConsultationMessageBubble from './ConsultationMessageBubble';
import ConsultationDeclinedMessage from './ConsultationDeclinedMessage';

interface ConsultationDetailDeclinedProps {
  serviceRequest: ConsultationRequestResBody;
}

const ConsultationDetailDeclined = (props: ConsultationDetailDeclinedProps) => {
  const {authStore} = useStores();

  // console.log(props.serviceRequest.recommendationType,'dsa');

 

  
  

  return (
    <View style={styles.body}>
      <ConsultationRequestMessage
        message={props.serviceRequest.note?.[0]?.text}
        timestamp={new Date(props.serviceRequest.note?.[0]?.time)}
        owner={authStore.userRole === 'patient'}
      />

      {authStore.userRole === 'practitioner' && (
        <ConsultationMessageAttachment
          messageType={
            authStore.userRole === 'practitioner' ? 'incoming' : 'outgoing'
          }
          attribute={{
            Type: 'history',
          }}
          serviceRequest={props.serviceRequest}
        />
      )}

      {props.serviceRequest.note?.[1] && (
        <ConsultationMessageBubble
          message={props.serviceRequest.note?.[1]?.text}
          timestamp={new Date(props.serviceRequest.note?.[1]?.time)}
          owner={authStore.userRole === 'practitioner'}
          isPatient={false}
          onStartGenerating={() => {}}
          onStopGenerating={() => {}}
        />
      )}

      <ConsultationDeclinedMessage 
        recommendationType={props.serviceRequest.recommendationType}
        recommendationValue={props.serviceRequest.recommendationValue}
        recommendationDoctorDetails={props?.serviceRequest?.recommendedPractitioner}
        timestamp={new Date(props.serviceRequest.modifiedOn)}
        owner={authStore.userRole === 'practitioner'}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  body: {
    paddingVertical: 12,
  },
});

export default memo(ConsultationDetailDeclined);
